export class ActivationCodeInfoDTO {
  constructor() {
    this.code = null;
    this.activation_id = null;
    this.player_id = null;
    this.tag = null;
    this.username = null;
    this.pfp = null;
    this.pfp_client_render_attributes = null;
  }
}